import { DrupalNodeExternalResource } from "@/types"
import { AcquiaCliResource } from "../acli/backend"
import { PageInterface } from "@/components/page/PageInterface"
import { MetadataRoute } from "next"
import { AcquiaDamResource } from "../dam/backend"

export interface ExternalResourceInterface<Context extends {} = {}> {
  /**
   * Use the document sidebar.
   */
  readonly useDocumentSidebar: boolean

  /**
   * Use the table of contents.
   */
  readonly useTableOfContents: boolean

  /**
   * Return the title for the current page.
   * @param slug The slug of the page.
   */
  getPageTitle(slug: string): Promise<string>

  /**
   * Return the children of the header.
   *
   * Use this to add additional elements to the header.
   *
   * @param slug The slug of the page.
   */
  getHeaderChildren(slug: string): Promise<JSX.Element>

  /**
   * Return the context for the current page.
   *
   * Populates the 'external' property in the useContentRoute react hook.
   */
  getContext():Promise<Context>

  /**
   * Return the sidebar for the current page.
   * @param context 
   */
  getSidebar(context: PageInterface<DrupalNodeExternalResource>):Promise<JSX.Element>

  /**
   * Return the content for the current page.
   * @param context 
   */
  getPageContent(context: PageInterface<DrupalNodeExternalResource>):Promise<JSX.Element>
  
  /**
   * Build a sitemap for the provided resource.
   *
   * @param baseUrl
   */
  buildSitemap(baseUrl: string):Promise<MetadataRoute.Sitemap>
}

export const LoadExternalResource = (node:DrupalNodeExternalResource):ExternalResourceInterface => {
  switch (node.field_renderer) {
    case 'acquia_cli':
      return new AcquiaCliResource(node)
    case 'markdown_for_dam_sdk':
      return new AcquiaDamResource(node)
  }
  throw new Error('Unknown resource type: ' + node.field_renderer)
}